var React = require('react');

function CaretLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36 18L0.878049 18","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M17.561 5.96046e-05C17.561 9.69872 9.69872 17.561 5.96046e-05 17.561","stroke":"white","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M5.96046e-05 18.439C9.69872 18.439 17.561 26.3013 17.561 35.9999","stroke":"white","strokeWidth":"3","key":2})]);
}

CaretLeft.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CaretLeft;

CaretLeft.default = CaretLeft;
